"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ReactIs = __importStar(require("react-is"));

var ReactUtils =
/** @class */
function () {
  function ReactUtils() {}

  ReactUtils.map = function (node, callback) {
    if (!node) {
      return;
    }

    if (node instanceof Array) {
      return node.map(callback);
    }

    if (ReactIs.isFragment(node)) {
      return React.Children.map(node.props.children, callback);
    }

    return callback(node, 0);
  };

  return ReactUtils;
}();

exports.ReactUtils = ReactUtils;